import store from "@/store";
import { isProduction } from "@/utils/env.js";

// Companies are let into the inspections beta through this flag. It is an
// admin-created row on AFP's FeatureFlag table, like the other viewer flags —
// there is no seed migration for it.
export const DAMAGE_DETECTION_FLAG = "airteam-inspections";

/**
 * Whether the damage detection mode is offered at all.
 *
 * Only production honours the flag. Staging, UAT and local dev are where the
 * beta is demoed and tested, so every project there has it — gating those on
 * the flag too would mean nobody could try the feature without a company row.
 *
 * Reactive inside a computed: reading the flag reads `state.flags`, so the
 * caller re-evaluates once the feature flags have been fetched.
 */
export const damageDetectionAvailable = () =>
  !isProduction || store.getters.featureFlag(DAMAGE_DETECTION_FLAG) === true;

/**
 * When this project was switched on to the damage detection, as a timestamp in
 * milliseconds, or null while it never was.
 *
 * The backend stamps it from the same clock it writes annotation `dateAdded`
 * with, which is what makes the two comparable when the damages are ordered.
 */
export const detectionActivatedAt = () => {
  const activatedAt =
    store.state.section?.config?.damage_detection_mode_activated_at;
  const time = activatedAt ? new Date(activatedAt).getTime() : NaN;
  return Number.isNaN(time) ? null : time;
};

/** Whether this project has confirmed the beta modal. */
export const damageDetectionActivated = () => detectionActivatedAt() !== null;
